import { Const } from '~/constants/Const.constant';
import { battery, configured, lastSeen, mfgId, reachable } from '~/helpers/fields-description';
import { Endpoint } from '~/interfaces/device.interface';
import { NAModule } from '~/models/modules/NAModule.model';
export class Sensor extends NAModule {
    isWired = false;
    hasOperationReset = false;
    endpoints: Endpoint[] = [];
    battery_levels = {
        full: Const.NABatteryLevelMagellan.NLT_LEVEL_0,
        high: Const.NABatteryLevelMagellan.NLT_LEVEL_1,
        medium: Const.NABatteryLevelMagellan.NLT_LEVEL_2,
        low: Const.NABatteryLevelMagellan.NLT_LEVEL_3,
    };

    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }

}
